import t from "@ext/localization/locale/translate";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@ui-kit/AlertDialog";
import { CheckboxField } from "@ui-kit/Checkbox";
import { Icon } from "@ui-kit/Icon";
import { useState } from "react";
import { renderWithBranches } from "./BranchCheckoutText";

type BranchCheckoutDialogProps = {
	fromBranch: string;
	toBranch: string;
	onConfirm: (choice: { mode: "transfer"; hideConfirmation: boolean }) => void;
	onCancel: () => void;
};

export const BranchCheckoutDialog = ({ fromBranch, toBranch, onConfirm, onCancel }: BranchCheckoutDialogProps) => {
	const [hideConfirmation, setHideConfirmation] = useState(false);

	return (
		<AlertDialog onOpenChange={(open) => !open && onCancel()} open>
			<AlertDialogContent>
				<AlertDialogCancel
					aria-label={t("close")}
					className="absolute right-3 top-3 h-6 w-6 p-0"
					onClick={onCancel}
					variant="text"
				>
					<Icon icon="x" />
				</AlertDialogCancel>
				<AlertDialogHeader>
					<AlertDialogTitle className="pr-6">
						{renderWithBranches(t("git.checkout.transfer-title"), { branch: toBranch })}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{renderWithBranches(t("git.checkout.transfer-description"), { from: fromBranch, to: toBranch })}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<CheckboxField
					checked={hideConfirmation}
					description={t("git.checkout.remember-choice-hint")}
					label={t("git.checkout.do-not-show-dialog-again")}
					onCheckedChange={(checked: boolean) => setHideConfirmation(checked)}
				/>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={onCancel} variant="outline">
						{t("cancel")}
					</AlertDialogCancel>
					<AlertDialogAction onClick={() => onConfirm({ mode: "transfer", hideConfirmation })}>
						{t("git.checkout.transfer")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
